import React from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "react-i18next";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  /** Colore del pulsante di conferma. "error" (default) = azione distruttiva (mostra l'icona di avviso). */
  confirmColor?: "error" | "primary" | "success";
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export function ConfirmDialog({
  open, title, message,
  confirmLabel, confirmColor = "error", onConfirm, onCancel, loading
}: ConfirmDialogProps) {
  const { t } = useTranslation();
  const destructive = confirmColor === "error";
  const titleText = title ?? t("common.confirmDeleteTitle");
  const confirmText = confirmLabel ?? t("common.delete");
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {destructive && <WarningAmberIcon color="warning" />}
        {titleText}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={loading}>{t("common.cancel")}</Button>
        <Button variant="contained" color={confirmColor} onClick={onConfirm} disabled={loading}>
          {loading ? "..." : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
